var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 14.4331C7.7935 14.4331 7.5935 14.4064 7.42683 14.3464C4.88016 13.4731 0.833496 10.3731 0.833496 5.79307C0.833496 3.45974 2.72016 1.56641 5.04016 1.56641C6.16683 1.56641 7.22016 2.00641 8.00016 2.79307C8.78016 2.00641 9.8335 1.56641 10.9602 1.56641C13.2802 1.56641 15.1668 3.46641 15.1668 5.79307C15.1668 10.3797 11.1202 13.4731 8.5735 14.3464C8.40683 14.4064 8.20683 14.4331 8.00016 14.4331ZM5.04016 2.56641C3.2735 2.56641 1.8335 4.01307 1.8335 5.79307C1.8335 10.3464 6.2135 12.8797 7.7535 13.4064C7.8735 13.4464 8.1335 13.4464 8.2535 13.4064C9.78683 12.8797 14.1735 10.3531 14.1735 5.79307C14.1735 4.01307 12.7335 2.56641 10.9668 2.56641C9.9535 2.56641 9.0135 3.03974 8.40683 3.85974C8.22016 4.11307 7.7935 4.11307 7.60683 3.85974C6.98683 3.03307 6.0535 2.56641 5.04016 2.56641Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.9615b4aec7ce48982e4008ae9b2d9040.svg";
export { ForwardRef as ReactComponent };